import axios from 'axios'
import Cookies from 'js-cookie'
import useSWR from 'swr'

import { API_PARAMS } from '../../../config/consts'
import { formatDateToStr } from '../../../utils/display'

interface GetPushNotificationCountViewedRequest {
  serviceId: string
  siteId?: string | null
  floorId?: string | null
  siteGroupId?: string | null
  fromDate: Date | null // '2021-01-01'
  toDate: Date | null // '2021-01-02'
}

interface GetPushNotificationCountViewedResponse {
  statusCode: number
  statusMessage: string
  currentPeriodValue: number
  pushNotificationCountViewedDatas: {
    date: string
    value: number
  }[]
}

const useGetPushNotificationCountViewed = ({
  serviceId,
  siteId,
  floorId,
  siteGroupId,
  fromDate,
  toDate,
}: GetPushNotificationCountViewedRequest) => {
  const accessToken = Cookies.get('LoginToken')
  const fetcher = (url: string): Promise<GetPushNotificationCountViewedResponse> =>
    axios.get(url).then((res) => res.data)

  const url = new URL(`${process.env.REACT_APP_CITRUS_API_DOMAIN}/api/getPushNotificationCountViewed`)
  url.searchParams.append('accessToken', accessToken ?? '')
  url.searchParams.append('serviceId', serviceId)
  if (siteGroupId && siteGroupId !== '') {
    url.searchParams.append('siteGroupId', siteGroupId)
  } else if (floorId && floorId !== API_PARAMS.SELECT_ALL) {
    url.searchParams.append('floorId', floorId)
  } else {
    url.searchParams.append('siteId', siteId ?? API_PARAMS.SELECT_ALL)
  }
  url.searchParams.append('fromDate', formatDateToStr(fromDate))
  url.searchParams.append('toDate', formatDateToStr(toDate))

  const { data, isLoading, mutate } = useSWR(
    () => accessToken && serviceId && fromDate && toDate && url.href,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    },
  )

  return {
    pushNotificationCountViewed: data,
    pushNotificationCountViewedLoading: isLoading,
    pushNotificationCountViewedMutate: mutate,
  }
}

export default useGetPushNotificationCountViewed
